import React from 'react'
import { Text } from 'rebass'
import {
  Paragraph,
  MainHeader,
  SubHeader,
  SectionHeader,
} from '../atoms/RulesTypography'

const SfvRules = () => {
  return (
    <>
      <MainHeader />
      <SubHeader text="Street Fighter V" />
      <SectionHeader text="rulebooks" />
      <Paragraph>
          CSL Street Fighter V 2020-2021 Circuit Rulebook: <a href="https://drive.google.com/file/d/1jL4cqGzqbWNkIzivktJyTxp3YyPEoEer/view?usp=sharing" target="_blank" rel="noopener noreferrer">
            CSL-Street-Fighter-V-2020-2021-Rules.pdf
          </a>
      </Paragraph>
      <Text mb={'1rem'}>
        <h3>
          FOR ANY Street Fighter V RELATED QUESTIONS - PLEASE FEEL FREE TO EMAIL US AT{'  '}
          <a href="mailto:support@cslesports.gg" target="_top">
            SUPPORT@CSLESPORTS.GG{' '}
          </a>
          OR SPEAK TO AN ADMIN on{' '}
          <a href="https://discord.gg/cslesportsgg" target="_blank" rel="noopener noreferrer">
            DISCORD
          </a>{' '}
          in the #sfv-help chat.
        </h3>
      </Text>
    </>
  )
}

export default SfvRules
